import {v35} from './v35';
import md5 from './md5';

export const v3 = v35('v3', 0x30, md5);
